import camelCase from 'lodash.camelcase';

import type { DeliveryMessageConfig } from './types';

export type Data = Record<string, string | undefined>;

export function generateBaseKey(config: DeliveryMessageConfig) {
    const { disableLeadTime, deliveryType, isAvailable } = config;

    const availabilityKey = isAvailable ? 'Available' : 'Unavailable';
    const leadTimeKey = disableLeadTime ? '__no_lead_time__' : '';

    return camelCase(`${deliveryType}_${availabilityKey}_Message${leadTimeKey}`);
}

export function generatePageKey(baseKey: string, pageType?: DeliveryMessageConfig['pageType']) {
    if (pageType) {
        return camelCase(`${baseKey}_${pageType}`);
    }

    return baseKey;
}

export function getDeliveryMessage(data: Data, config: DeliveryMessageConfig): string | undefined {
    const baseKey = generateBaseKey(config);
    const pageKey = generatePageKey(baseKey, config.pageType);

    return data[pageKey] ?? data[baseKey] ?? undefined;
}
